import { SelectOption } from '../../appTypes';

const dslrCaseAndOptics: any = {
  Canon: [
    'EOS 1D mark III',
    'EOS 1Ds mark III',
    'EOS D60',
    'EOS 5D',
    'EOS 5D MARK II',
    'EOS 7D',
    'EOS 60D',
    'EOS 5D MARK III',
    'EOS 5Ds',
    'EOS 60 Da',
    'EOS-1D X',
    'EOS 6D',
    'EOS 70D',
    'EOS 70D MARK II',
    'EOS M3',
    'Autre',
  ],
  Nikon: [
    'D1',
    'D1X',
    'D1H',
    'D100',
    'D2H',
    'D2Xs',
    'D2Hs',
    'D200',
    'D3',
    'D3s',
    'D3x',
    'D300',
    'D300s',
    'D3000',
    'D3100',
    'D3200',
    'D3300',
    'D4',
    'D40',
    'D40x',
    'D5',
    'D50',
    'D500',
    'D5000',
    'D5100',
    'D5200',
    'D5300',
    'D5500',
    'D60',
    'D610',
    'D70',
    'D70s',
    'D700',
    'D750',
    'D7000',
    'D7100',
    'D7200',
    'D810A',
    'D80',
    'D810',
    'D90',
    'Autre',
  ],
  Sony: [
    'α900',
    'α850',
    'α99',
    'α100',
    'α700',
    'α200',
    'α300',
    'α350',
    'α230',
    'α330',
    'α380',
    'α500',
    'α550',
    'α450',
    'α290',
    'α390',
    'α560',
    'α580',
    'α33',
    'α55',
    'α35',
    'α65',
    'α57',
    'α37',
    'α58',
    'α77',
    'Autre',
  ],
  Pentax: [],
  Olympus: [],
  Lumix: [],
};

export const Brands: SelectOption[] = Object.keys(
  dslrCaseAndOptics,
).map(label => ({ label, key: label }));

export const MatterportBrands: SelectOption[] = [
  { key: 'pro1', label: 'Matterport Pro 1' },
  { key: 'pro2', label: 'Matterport Pro 2' },
  { key: 'pro2lite', label: 'Matterport Pro 2 Lite' },
  { key: 'insta360', label: 'Insta 360' },
  { key: 'ricohteta', label: 'Ricoh Teta' },
];

export const dslrBrands = (dslrCase: string): SelectOption[] => {
  return (
    dslrCaseAndOptics[dslrCase] &&
    dslrCaseAndOptics[dslrCase].map((label: string) => ({ label, key: label }))
  );
};
